import generateNameOrc from "./../orc/generateNameOrc"
import generateNameHuman from "./../human/generateNameHuman"

export default (...params) => Math.random() > 0.5
  ? generateNameOrc(...params)
  : generateNameHuman(...params)
